import { useState, useEffect } from 'react';
import { useLang } from '../../context/LangContext';
import { supabase } from '../../lib/supabase';
import { COLORS } from '../../lib/constants';

export default function Home({ onSelectBusiness }) {
  const { isRtl } = useLang();
  const [categories, setCategories] = useState([]);
  const [businesses, setBusinesses] = useState([]);
  const [ads, setAds] = useState([]);
  const [adIndex, setAdIndex] = useState(0);
  const [search, setSearch] = useState('');
  const [selectedCat, setSelectedCat] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchData(); }, []);

  useEffect(() => {
    if (ads.length < 2) return;
    const timer = setInterval(() => setAdIndex(i => (i + 1) % ads.length), 4000);
    return () => clearInterval(timer);
  }, [ads]);

  const fetchData = async () => {
    const [catsRes, bizRes, adsRes] = await Promise.all([
      supabase.from('categories').select('*').eq('is_active', true).order('sort_order'),
      supabase.from('businesses').select('*').eq('status', 'active'),
      supabase.from('ads').select('*').eq('is_active', true).order('sort_order'),
    ]);
    setCategories(catsRes.data || []);
    setBusinesses(bizRes.data || []);
    setAds(adsRes.data || []);
    setLoading(false);
  };

  const filtered = businesses.filter(b => {
    const matchCat = selectedCat ? b.category_id === selectedCat : true;
    const name = isRtl ? b.name_ar : (b.name_en || b.name_ar);
    const matchSearch = name ? name.toLowerCase().includes(search.toLowerCase()) : false;
    return matchCat && matchSearch;
  });

  return (
    <div style={{ background: COLORS.bg, minHeight: '100vh', fontFamily: 'Cairo, sans-serif', direction: isRtl ? 'rtl' : 'ltr' }}>
      <div style={{ background: `linear-gradient(135deg, ${COLORS.primary}, ${COLORS.primaryDark})`, padding: '20px 16px 28px', color: '#fff' }}>
        <div style={{ fontSize: 22, fontWeight: 900, marginBottom: 2 }}>{isRtl ? 'جَدوِل 🗓️' : 'Jadwil 🗓️'}</div>
        <div style={{ fontSize: 12, opacity: 0.7, marginBottom: 4 }}>{isRtl ? 'Jadwil' : 'جَدوِل'}</div>
        <div style={{ fontSize: 13, opacity: 0.85, marginBottom: 16 }}>{isRtl ? 'احجز موعدك بسهولة' : 'Book your appointment easily'}</div>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder={isRtl ? '🔍 ابحث عن صالون أو خدمة...' : '🔍 Search salon or service...'} style={{ width: '100%', padding: '13px 16px', borderRadius: 14, border: 'none', fontSize: 14, fontFamily: 'Cairo, sans-serif', direction: isRtl ? 'rtl' : 'ltr', outline: 'none', boxSizing: 'border-box', boxShadow: '0 4px 20px rgba(0,0,0,0.15)' }} />
      </div>

      <div style={{ padding: '0 16px', marginTop: -12 }}>
        {ads.length > 0 && (
          <div style={{ borderRadius: 16, overflow: 'hidden', marginBottom: 20, boxShadow: '0 4px 20px rgba(0,0,0,0.1)', position: 'relative', height: 160 }}>
            {ads[adIndex].media_type === 'video'
              ? <video src={ads[adIndex].media_url} autoPlay muted loop style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              : <img src={ads[adIndex].media_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            }
            {ads[adIndex].title_ar && (
              <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, background: 'linear-gradient(transparent, rgba(0,0,0,0.7))', padding: '20px 16px 12px', color: '#fff', fontSize: 15, fontWeight: 700 }}>
                {isRtl ? ads[adIndex].title_ar : (ads[adIndex].title_en || ads[adIndex].title_ar)}
              </div>
            )}
            {ads.length > 1 && (
              <div style={{ position: 'absolute', bottom: 8, right: 0, left: 0, display: 'flex', justifyContent: 'center', gap: 4 }}>
                {ads.map((_, i) => (
                  <div key={i} onClick={() => setAdIndex(i)} style={{ width: i === adIndex ? 20 : 6, height: 6, borderRadius: 3, background: i === adIndex ? '#fff' : 'rgba(255,255,255,0.5)', cursor: 'pointer', transition: 'all .3s' }} />
                ))}
              </div>
            )}
          </div>
        )}

        {categories.length > 0 && (
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: COLORS.text, marginBottom: 12 }}>{isRtl ? 'تصفح حسب الفئة' : 'Browse by Category'}</div>
            <div style={{ display: 'flex', gap: 10, overflowX: 'auto', paddingBottom: 4 }}>
              <button onClick={() => setSelectedCat(null)} style={{ flexShrink: 0, padding: '8px 16px', borderRadius: 20, border: `1.5px solid ${selectedCat === null ? COLORS.primary : COLORS.border}`, background: selectedCat === null ? COLORS.primaryLight : '#fff', color: selectedCat === null ? COLORS.primary : COLORS.textMuted, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'Cairo, sans-serif' }}>
                {isRtl ? 'الكل' : 'All'}
              </button>
              {categories.map(cat => (
                <button key={cat.id} onClick={() => setSelectedCat(cat.id === selectedCat ? null : cat.id)} style={{ flexShrink: 0, padding: '8px 16px', borderRadius: 20, border: `1.5px solid ${selectedCat === cat.id ? COLORS.primary : COLORS.border}`, background: selectedCat === cat.id ? COLORS.primaryLight : '#fff', color: selectedCat === cat.id ? COLORS.primary : COLORS.textMuted, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'Cairo, sans-serif', display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span>{cat.icon}</span>
                  <span>{isRtl ? cat.name_ar : cat.name_en}</span>
                </button>
              ))}
            </div>
          </div>
        )}

        <div style={{ fontSize: 15, fontWeight: 700, color: COLORS.text, marginBottom: 12 }}>
          {isRtl ? `${filtered.length} مكان متاح` : `${filtered.length} places available`}
        </div>

        {loading && <div style={{ textAlign: 'center', padding: 40, color: COLORS.textMuted }}>{isRtl ? 'جارٍ التحميل...' : 'Loading...'}</div>}

        {!loading && filtered.length === 0 && (
          <div style={{ textAlign: 'center', padding: 40 }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>🔍</div>
            <div style={{ color: COLORS.textMuted, fontSize: 14 }}>{isRtl ? 'لا توجد نتائج' : 'No results found'}</div>
          </div>
        )}

        {filtered.map(biz => (
          <div key={biz.id} onClick={() => onSelectBusiness(biz)} style={{ background: '#fff', borderRadius: 16, padding: 16, marginBottom: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', cursor: 'pointer', border: `1px solid ${COLORS.border}`, display: 'flex', gap: 14, alignItems: 'center' }}>
            <div style={{ width: 64, height: 64, borderRadius: 14, background: COLORS.primaryLight, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, flexShrink: 0, overflow: 'hidden' }}>
              {biz.logo_url ? <img src={biz.logo_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : '🏪'}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: COLORS.text, marginBottom: 3 }}>{isRtl ? biz.name_ar : (biz.name_en || biz.name_ar)}</div>
              <div style={{ fontSize: 12, color: COLORS.textMuted, marginBottom: 6 }}>📍 {biz.district ? `${biz.district}، ` : ''}{biz.city}</div>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                {biz.rating > 0 && <span style={{ fontSize: 12, color: '#F59E0B', fontWeight: 600 }}>⭐ {Number(biz.rating).toFixed(1)}</span>}
                {biz.type === 'mobile' && <span style={{ fontSize: 11, background: '#EEF2FF', color: '#4F46E5', padding: '2px 8px', borderRadius: 10, fontWeight: 600 }}>{isRtl ? '🚗 متنقل' : '🚗 Mobile'}</span>}
                {biz.type === 'hybrid' && <span style={{ fontSize: 11, background: '#F0FDF4', color: '#16A34A', padding: '2px 8px', borderRadius: 10, fontWeight: 600 }}>{isRtl ? '🏠 ثابت + متنقل' : '🏠 Fixed + Mobile'}</span>}
                {biz.is_featured && <span style={{ fontSize: 11, background: '#FFF7ED', color: '#EA580C', padding: '2px 8px', borderRadius: 10, fontWeight: 600 }}>{isRtl ? '⭐ مميز' : '⭐ Featured'}</span>}
              </div>
            </div>
            <div style={{ color: COLORS.textMuted, fontSize: 18 }}>{isRtl ? '‹' : '›'}</div>
          </div>
        ))}
        <div style={{ height: 80 }} />
      </div>
    </div>
  );
}
